// extracted by mini-css-extract-plugin
export default {"nameCell":"columns_nameCell__Gd0A8"};